import { useEffect } from 'react';
import '../personDetails.css';


const DefaultComponent: React.FC = () => {


  useEffect(()=>{
      document.title = 'Page not found on camgirlcrawler.net ';
      let descMeta=document.querySelector("meta[name='description']");
      if(descMeta!==null)descMeta.setAttribute("content", 'Ooops!, your page requested is not found on camgirlcrawler.net');
      let canNAme=document.querySelector("link[rel='canonical']");
      if(canNAme!==null)canNAme.setAttribute("href", 'https://www.camgirlcrawler.net/not-found/');
}, []); // empty array means only once


return (
  <div>
      <div className='pageHeader'>
              <h1>Ooops, page not found!</h1>
              <div><b><i>Here is some links to get you going again!</i></b></div>
      </div>
		   <br/><br/>
		  <br/>
		  <br/>
      <div style={{textAlign:"center",width:"100%"}}>
        <a href="/camgirl-search">
          <button className="btn btn-success">Try our camgirl category and tag search engine!</button>
        </a>
		  </div>
		  <br/>
		  <br/>
      <div style={{textAlign:"center",width:"100%"}}>
        <a href="/">
          <button className="btn btn-success">Try our camgirl name search engine!</button>
        </a>
		  </div>
  </div>
  );
}
export default DefaultComponent;